import React from 'react'
import { FilterControl } from './FilterControl'
import { Task } from './Task'
import { deleteDoc, doc } from 'firebase/firestore'
import db from '../utils/firebase'

/* TASKLIST TODOS
How do we DELETE a collection from our Firestore db?

- import deleteDoc, and doc from 'firebase/firestore'
- import db from '../utils/firebase'
- use deleteDoc in clearCompleted
- deleteDoc(docRef, id) 
*/


export const TaskList = ({tasks, setTasks,filterStatus,setFilterStatus, filteredTasks,userId}) => {

  const clearCompleted = ()=> {
    //Clear's Tasks by filtering out
      // setTasks(tasks.filter((task)=> !task.status))

    //With Firebase we can delete a document
    // const docRef =  doc(db,"tasks", tasks.id)
    filteredTasks.forEach((item)=> {
      if(item.status === true){
      deleteDoc(doc(db,"tasks",item.id))
    }
    
    })
    // Reset the filterStatus to all
      // setFilterStatus("all")
  }
  

  return (
    
    <div className='task-list-wrapper'>
        <div className='task-list'>
            {filteredTasks.map((task)=> {
        
                return <Task 
                    text = {task.text}
                    status = {task.staus}
                    tasks = {tasks}
                    setTasks = {setTasks}
                    task = {task}
                    key = {task.id}
                    filteredTasks = {filteredTasks}
                    userId = {userId}
                    />
            })}

        </div>

        <div className='task-items-info'>
            <div className='items-left'>
                {filteredTasks.length} items left
            </div>

            <FilterControl 
                filterStatus = {filterStatus}
                setFilterStatus = {setFilterStatus}
            />

            <div className='items-clear'>
                <span onClick={clearCompleted}>Clear Completed</span>
            </div>
        </div>
           
    </div>

  
  )
}
